import { lazy } from "react";
import { MessageSquare } from "lucide-react";
import type { AdminModule } from "../types";

const Overview = lazy(() => import("./pages/Overview").then((m) => ({ default: m.Overview })));
const Log = lazy(() => import("./pages/Log").then((m) => ({ default: m.Log })));
const Limits = lazy(() => import("./pages/Limits").then((m) => ({ default: m.Limits })));

/**
 * RFC-670 — SMS gateway module. Balance, spend against the daily ceiling, the
 * send log, and the live rate-limit counters. Before this the only way to read
 * the balance was to curl Telnyx by hand and there was no send log at all.
 */
export const smsModule: AdminModule = {
  key: "sms",
  label: "SMS",
  description: "Gateway balance, daily spend, the send log, and rate limits.",
  group: "services",
  icon: MessageSquare,
  requiredPermission: "admin.sms.read",
  routes: [
    { path: "overview", label: "Overview", element: <Overview /> },
    { path: "log", label: "Log", element: <Log /> },
    { path: "limits", label: "Limits", element: <Limits /> },
  ],
};
